module.exports = __webpack_public_path__ + "media/images/freejob-logo-1a91e311c2fb88faf93508ab26590d03.png";